import React from 'react'
import { Button, ButtonVariants } from 'rds'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { cartAddItem } from '../../reducers/cartReducer'
import { getProductIsInCart } from '../../utils/product'

const CartButton = ({
    className,
    style = {},
    product,
    fullWidth,
    disabled = false,
    variant,
    additionals = {},
    notes,
    quantity = 1,
    isOutOfStock = false,
}) => {
    const dispatch = useDispatch()
    const sessionUser = useSelector(state => state.session.user, shallowEqual)
    const cartEntries = useSelector(state => state.cart.entries, shallowEqual)
    const cartFetching = useSelector(state => state.cart.isFetching)
    const [isInCart, setIsInCart] = React.useState(false)
    const [addingToCart, setAddingToCart] = React.useState(false)
    const hasMatchingVariant = !!variant._id
    const isDisabled = !hasMatchingVariant || disabled || isInCart

    React.useEffect(() => {
        if (!Array.isArray(product.variants) || !hasMatchingVariant) {
            return
        }
        const isInCart = getProductIsInCart(
            cartEntries,
            product,
            variant,
            additionals,
            notes,
        )
        setIsInCart(isInCart)
    }, [product, additionals, notes, hasMatchingVariant, variant, cartEntries])

    React.useEffect(() => {
        if (!addingToCart || cartFetching) return
        setTimeout(() => {
            setAddingToCart(false)
        }, 500)
    }, [addingToCart, cartFetching])

    const handleAddToCart = () => {
        setAddingToCart(true)
        dispatch(
            cartAddItem(
                sessionUser,
                product,
                variant,
                additionals,
                notes,
                quantity,
            ),
        )
    }

    const getLabel = () => {
        if (!hasMatchingVariant) {
            return 'No disponible'
        } else if (isOutOfStock) {
            return 'Sin stock'
        } else if (isInCart) {
            return 'Lo tienes en el carrito'
        } else if (addingToCart) {
            return 'Agregando...'
        }
        return 'Añadir al carrito'
    }

    return (
        <Button
            className={`add-to-cart-button ${className || ''}`}
            style={{
                ...style,
                width: fullWidth ? '100%' : null,
            }}
            label={getLabel()}
            variant={ButtonVariants.MAIN}
            onClick={!isInCart && !addingToCart ? handleAddToCart : null}
            icon={isDisabled ? null : 'ShoppingCartAdd'}
            disabled={isDisabled}
        />
    )
}

export default CartButton
